import {
  DOWNLOAD_CONTACT_DATA_REQUEST,
  DOWNLOAD_CONTACT_DATA_SUCCESS,
  DOWNLOAD_CONTACT_DATA_ERROR,
  statusType
} from '../../actions'

const initial = {
  status: statusType.IDLE
}

const contactExport = (state = initial, action) => {
  switch (action.type) {
    case DOWNLOAD_CONTACT_DATA_REQUEST:
      return {
        status: statusType.IN_PROGRESS
      }

    case DOWNLOAD_CONTACT_DATA_SUCCESS:
      return {
        status: statusType.SUCCESS
      }

    case DOWNLOAD_CONTACT_DATA_ERROR:
      return {
        status: statusType.ERROR
      }

    default:
      return state
  }
}

export default contactExport
